export function getFriendlyTenantName(orig: string): string {
  return orig.slice(8); // remove $tenant-
}

export const validateEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const getStripeUrl = (stripeId: string) => {
  if (stripeId.startsWith("sub_sched")) return `https://dashboard.stripe.com/subscription_schedules/${stripeId}`;
  return `https://dashboard.stripe.com/subscriptions/${stripeId}`;
};

export const validateGuid = (str: string): boolean => {
  const regex = new RegExp(/^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/);
  if (str === null || str === undefined) return false;
  if (regex.test(str)) return true;
  else return false;
};
